module.exports = __webpack_public_path__ + "static/media/Picture1.1710169b.jpg";